/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_None_SelectedInputs */



/**
* | output |
* | --- |
* | "No preset selected" |
*
* @param {Video_Export_Preset_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_none_selected = /** @type {((inputs?: Video_Export_Preset_None_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_None_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun prereglage selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Voreinstellung ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно заданные параметры не выбраны")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha seleccionado ningún ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择预设值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई पूर्व निर्धारित सेटिंग चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma predefinição selecionada")
	return /** @type {LocalizedString} */ ("No preset selected")
});